import isFunction from 'lodash/isFunction';

import isClass from './isClass';

export default (v) => isFunction(v) && !isClass(v);
